import React, { Component } from 'react';
import './TotalCss.css'
import './FetchData.css';
import Swal from 'sweetalert2';
import { api_url } from "./globalFunction/global_string";

export class FetchDataApply extends Component {
  static displayName = FetchDataApply.name;

  componentDidUpdate(prevProps) {
    if (this.props.isFetchDataApply !== prevProps.isFetchDataApply) {
      this.populateWeatherData();
    }
  }
  constructor(props) {
    super(props);
    this.state = {
      fetchDataForTableApply: props.fetchDataForTableApply,
      isFetchDataApply: props.isFetchDataApply,
      forecasts: [],
      loading: true,
      sortColumn: null,
      columnSort: { url_addr: 'asc', unit_name: 'asc', build_id: 'asc', build_date: 'asc' }
    };
  }

  componentDidMount() {
    this.populateWeatherData();
  }


  renderTableHeader() {
    return (
      <thead>
        <tr>
          <th className='nancy_table_width20'>
            <div className="nancy-table-topC">流水號</div></th>
          <th className='nancy_table_width20'>
            <div className="nancy-table-topC">網站名稱</div></th>
          <th className='nancy_table_width20'>
            <div className="nancy-table-topC">掃描狀態</div></th>
          <th className='nancy_table_width20'>
            <div className="nancy-table-topC">掃描版本</div></th>
          <th className='nancy_table_width15'>
            <div className="nancy-table-top">建立人員</div></th>
          <th className='nancy_table_width15'>
            <div className="nancy-table-top">建立時間</div></th>
        </tr>
      </thead>
    );
  }

  renderTableBody(forecasts) {
    const filteredForecasts = forecasts.filter(forecast => forecast.scan_status === "0" || forecast.scan_status === "1");
    const limitedForecasts = filteredForecasts.slice(0, 8);

    if (!limitedForecasts || limitedForecasts.length === 0) {
      return <tbody></tbody>;
    }


    // 按日期從新到舊排序
    forecasts.sort((a, b) => {
      const dateA = a.build_date;
      const dateB = b.build_date;
      const formattedDateA = new Date(dateA.substring(0, 4), dateA.substring(4, 6) - 1, dateA.substring(6, 8));
      const formattedDateB = new Date(dateB.substring(0, 4), dateB.substring(4, 6) - 1, dateB.substring(6, 8));
      return formattedDateB - formattedDateA; // 降序排序
    });

    return (
      <tbody>
        {limitedForecasts.map((forecast) => {
          // console.log(forecast);
          let scanStatusText;
          let scanbetaversionText;
          if (forecast.scan_status === "0") {
            scanStatusText = "排程中";
          } else if (forecast.scan_status === "1") {
            scanStatusText = "掃描中";
          }
          if (forecast.betaversion === "1") {
            scanbetaversionText = "開發版";
          } else if (forecast.betaversion === "2") {
            scanbetaversionText = "測試版";
          } else if (forecast.betaversion === "3") {
            scanbetaversionText = "正式版";
          }
          const originalFormat = forecast.build_date;
          const newFormat = originalFormat.replace(/\//g, "").replace(/:/g, "").replace(/ /g, "");

          return (
            <tr key={forecast.id}>
              <td>
                {`${newFormat}-${forecast.local_net_id}-${forecast.local_unit_id}-${forecast.serial_no}`}
              </td>
              <td>
                <a href={forecast.url_addr}>
                  {forecast.url_name}
                </a>
              </td>
              <td>{scanStatusText}</td>
              <td>{scanbetaversionText}</td>
              <td>{forecast.build_id}</td>
              <td>{forecast.build_date}</td>
            </tr>
          );
        })}
      </tbody>
    );
  }

  render() {
    // 如果正在加載數據，顯示加載提示
    if (this.state.loading) {
      return <p><em>Loading...</em></p>;
    }

    // 數據加載完成後顯示表格和其他內容
    return (
      <div className='mt-2'>
        <table id='tablelabel' className='table table-striped table-bordered dt-responsive nowrap vertical-align-center' aria-labelledby="tableLabel">
          {this.renderTableHeader()}
          {this.renderTableBody(this.state.forecasts)}
        </table>
        <div style={{
          backgroundColor: 'lightblue',
          padding: '10px',
          borderRadius: '5px',
          marginTop: '20px'
        }}>
          <h4>注意說明</h4>
          <h5>申請前</h5>
          <ol>
            <li>請確保在防火牆上將140.113.27.234設定白名單。</li>
            <li>請確保被掃描主機網址是正確的，並且140.113.27.234能連到被掃描主機。</li>
            <li>因為網站弱點掃描會對伺服器進行大量網路封包傳輸，因此建議在同一個IP下的網站同時間最多排兩個網站掃描。</li>
            <li>因為網站弱點掃描有可能會導致網站、伺服器與資料庫資料異動或損毀，因此請確保在使用前對網站、伺服器與資料庫的資料進行備份。</li>
            <li>請注意使用網站弱點登入掃描，會對網站進行上傳檔案與資料等操作，容易造成網站或資料庫異動或損壞。請確保網站、伺服器與資料庫的資料有備份，或使用測試機進行掃描。</li>
          </ol>
          <h5>掃描完成後</h5>
          <ol>
            <li>請確保網站使用一切正常，如果有異動或損毀，請使用備份或其他手動復原。</li>
            <li>請確保移除140.113.27.234在防火牆的白名單。</li>
          </ol>


        </div>
      </div>
    );
  }


  async populateWeatherData() {
    const formData = new FormData();
    formData.append("user_type", this.state.fetchDataForTableApply.current_user_type);
    formData.append("local_net_id", this.state.fetchDataForTableApply.local_net_id);
    formData.append("local_unit_id", this.state.fetchDataForTableApply.local_unit_id);
    formData.append("user_id", localStorage.getItem('login_user_id'));

    await fetch(this.state.fetchDataForTableApply.fetchDataExcelApi, {
      method: "POST",
      headers: { "Authorization": localStorage.getItem('accessToken') },
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        //console.log(data)
        let arr_status = [String(data.statusCode), data.row, data.detail] //api 回傳判斷
        const rows = Array.isArray(arr_status[1]) ? arr_status[1] : [arr_status[1]];
        const pendingInspectionItems = data.row.filter(row => row.scan_status === "0" || row.scan_status === "1");
        console.log(pendingInspectionItems)
        this.setState({ forecasts: rows, loading: false });
        this.props.onPendingInspectionItemsChange(pendingInspectionItems);
      })
      .catch(error => {
        console.log('Error fetching JSON:', error);
      });
  }
}
